import React, { useState } from 'react';
import { CartItemsContextType } from './types/CartItemsContextType';

export const CartItemsContext =
  React.createContext<CartItemsContextType | null>(null);

type CartItemsProviderProps = {
  children: React.ReactNode;
};

const CartItemsProvider: React.FC<CartItemsProviderProps> = ({ children }) => {
  const [cartItems, setCartItems] = useState(0);
  const updateCartItems = (itemsCount: number) => {
    setCartItems(cartItems + itemsCount);
  };
  return (
    <CartItemsContext.Provider value={{ cartItems, updateCartItems }}>
      {children}
    </CartItemsContext.Provider>
  );
};

export default CartItemsProvider;
